import React from 'react'
import i18n from 'i18next'

import Typography from '../../../UniformComponents/Typography'
import correlationExplainer from '../assets/correlationexplainer.svg'

const CorrelationExplainer = () => (
    <div className="pp-slide-layout-container" style={{ height: '100%' }}>
        <div className="pp-slide-commentary-container">
            <Typography type="tiny" color="grey">{i18n.t('powerpoint.correlationexplainer.commentary')}</Typography>
        </div>

        <br />

        <div className="pp-summary-slide-content" style={{ height: 'calc(100% - 100px)' }}>
            <div style={{ display: 'flex', gap: 20, justifyContent: 'space-between', height: '100%', width: '100%', padding: 20, backgroundColor: 'white', borderRadius: 10, alignItems: 'center' }}>
                <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                    <img src={correlationExplainer} alt="nps-explainer" style={{ width: '100%', height: '100%' }} />

                    <div style={{ padding: 10, backgroundColor: '#FFFFFF80', display: 'flex', flexDirection: 'column', textAlign: 'center', position: 'absolute', top: '15%', left: '12%', maxHeight: '30%', overflowY: 'auto', maxWidth: '40%', width: 300 }}>
                        <Typography type="tiny-b">{i18n.t('powerpoint.correlationexplainer.highr.weakc.title')}</Typography>

                        <Typography type="tiny">{i18n.t('powerpoint.correlationexplainer.highr.weakc.body')}</Typography>
                    </div>

                    <div style={{ padding: 10, backgroundColor: '#FFFFFF80', display: 'flex', flexDirection: 'column', textAlign: 'center', position: 'absolute', top: '15%', right: '5%', maxHeight: '30%', overflowY: 'auto', maxWidth: '40%', width: 300 }}>
                        <Typography type="tiny-b">{i18n.t('powerpoint.correlationexplainer.highr.strongc.title')}</Typography>

                        <Typography type="tiny">{i18n.t('powerpoint.correlationexplainer.highr.strongc.body')}</Typography>
                    </div>

                    <div style={{ padding: 10, backgroundColor: '#FFFFFF80', display: 'flex', flexDirection: 'column', textAlign: 'center', position: 'absolute', bottom: '20%', left: '12%', maxHeight: '30%', overflowY: 'auto', maxWidth: '40%', width: 300 }}>
                        <Typography type="tiny-b">{i18n.t('powerpoint.correlationexplainer.lowr.weakc.title')}</Typography>

                        <Typography type="tiny">{i18n.t('powerpoint.correlationexplainer.lowr.weakc.body')}</Typography>
                    </div>

                    <div style={{ padding: 10, backgroundColor: '#FFFFFF80', display: 'flex', flexDirection: 'column', textAlign: 'center', position: 'absolute', bottom: '20%', right: '5%', maxHeight: '30%', overflowY: 'auto', maxWidth: '40%', width: 300 }}>
                        <Typography type="tiny-b">{i18n.t('powerpoint.correlationexplainer.lowr.strongc.title')}</Typography>

                        <Typography type="tiny">{i18n.t('powerpoint.correlationexplainer.lowr.strongc.body')}</Typography>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 20, backgroundColor: '#102E4A', borderRadius: 20, height: 'min-content', textAlign: 'center', maxWidth: '30%' }}>
                    <i className="far fa-circle-question" style={{ color: '#33E1D5', fontSize: 28 }} />

                    <Typography type="tiny-b" style={{ color: 'white' }}>{i18n.t('powerpoint.correlationexplainer.bubbletext')}</Typography>

                    <Typography type="tiny" style={{ color: 'white' }}>{i18n.t('powerpoint.correlationexplainer.bubbletext.1')}</Typography>
                </div>
            </div>
        </div>
    </div>
)

export default CorrelationExplainer
